<template>
  <div>
    <div class="breadlist">
      <bread-list :routeQuery="routeQuery"></bread-list>
    </div>
    <!-- <div class="typeTitle">课程分类</div> -->
    <div class="type-label-list">
      <button
        class="type-label"
        :class="{ 'chose-btn': choseItem.length == 0 }"
        @click="clearChose"
      >
        全部
      </button>
      <button
        class="type-label"
        v-for="(item, index) in lists"
        :key="index"
        @click="choseType(item)"
        :class="{ 'chose-btn': choseItem.includes(item.id) }"
      >
        {{ item.name }}
      </button>
    </div>
    <div class="type-label-list" v-if="routeQuery.two == '教学教材'">
      <button
        class="type-label"
        :class="{ 'chose-btn': courseChoseItem.length == 0 }"
        @click="clearCourseChose"
      >
        全部
      </button>
      <button
        class="type-label"
        v-for="(item, index) in courseTypeList"
        :key="index"
        @click="choseCourseType(item)"
        :class="{ 'chose-btn': courseChoseItem.includes(item.id) }"
      >
        {{ item.name }}
      </button>
    </div>
    <div class="video-list" v-if="videoData.length > 0">
      <div class="video-one" v-for="(item, index) in videoData" :key="index">
        <div
          class="video-show"
          @click="videoPlay(item)"
          :class="{ 'jc-height': routeQuery.two == '教学教材' }"
        >
          <!-- <img v-if="item.external" :src="item.coverFile.path" />
          <img v-else :src="item.coverFile.path" /> -->
          <img
            style="object-fit: cover"
            v-if="routeQuery.two == '教学视频'"
            :src="item.coverFile.path"
            @error="imgError"
          />
          <img v-else :src="item.path" @error="imgError" />
          <div class="video-play" v-if="routeQuery.two == '教学视频'"></div>
        </div>
        <div class="video-discribe" @click="videoPlay(item)">
          <div class="video-name overflow weight fs-md" :title="item.name">
            {{ item.name }}
          </div>
          <div
            class="video-date fs-sm overflow"
            v-if="routeQuery.two == '教学视频'"
          >
            {{ item.teacherName }} · {{ item.createTime | formateDate }}
          </div>
          <div class="video-date fs-sm overflow" v-else>
            {{ item.author }}
          </div>
        </div>
      </div>
    </div>
    <div class="empty" v-else>
      <img src="../../assets/img/emptybox.svg" />
      <div style="margin-top: 4px">该分类下暂无教材，换个试试</div>
    </div>
    <div class="page d-flex fs-md">
      <div class="pageNum">{{ total }}</div>
      条记录 共
      <div class="pageNum">{{ pageNum }}</div>
      页 当前第
      <div class="pageNum">{{ currPage }}</div>
      页
      <button
        class="port-btn"
        :class="{ 'default-btn': currPage == 1 }"
        @click="changeToFirst()"
      >
        首页
      </button>
      <button
        class="changpage-btn"
        :class="{ 'default-btn': currPage == 1 }"
        @click="changeToPrev()"
      >
        上一页
      </button>
      <button
        class="changpage-btn"
        :class="{ 'default-btn': currPage == pageNum || pageNum == 0 }"
        @click="changeToNext()"
      >
        下一页
      </button>
      <button
        class="port-btn"
        :class="{ 'default-btn': currPage == pageNum || pageNum == 0 }"
        @click="changeToLast()"
      >
        末页
      </button>
    </div>
  </div>
</template>
<script>
import { formateDate } from '../../assets/js/date'
import BreadList from '../../components/BreadList/indexnew.vue'
import { getVideoList, getVideoTypes } from '@/api/api'
import {
  getMaterialList,
  getMaterialType,
  getCourseType,
} from '@/api/api-teaching'
export default {
  components: {
    BreadList,
  },
  data() {
    return {
      lists: [
        // '短跑',
        // '长跑',
        // '立定跳远',
        // '跳绳',
        // '仰卧起坐',
        // '乒乓球',
        // '网球',
        // '羽毛球',
        // '篮球',
        // '足球',
        // '排球',
        // '健美操',
      ],
      courseTypeList: [],
      courseChoseItem: [],
      choseItem: [],
      videoData: [
        // {
        //   id: 0,
        //   name: '视频标题阿里斯顿就发来的飞机啊哦飞机啊哦',
        //   teacherName: '张三',
        //   createTime: '2022-02-10',
        //   coverFile: {
        //     path: require('../../assets/img/vedio01.png'),
        //   },
        // },
      ],
      routeQuery: '',
      total: 0,
      pageNum: 1,
      currPage: 1,
      limit: 8,
      twoName: '',
    }
  },
  filters: {
    formateDate(time) {
      let date = new Date(time)
      return formateDate(date, 'yyyy-MM-dd')
    },
  },
  created() {
    this.routeQuery = this.$route.query
    this.routeQuery.path1 = '/teaching'
    this.routeQuery.path2 = '/video'
    if (this.routeQuery.two == '教学视频') {
      this.getVideoLists()
      this.getTypes()
    } else if (this.routeQuery.two == '教学教材') {
      this.materialList()
      this.materialType()
      this.getCourseType()
    }
  },
  watch: {
    $route: {
      handler(newVal) {
        this.routeQuery = newVal.query
        this.routeQuery.path1 = '/teaching'
        this.routeQuery.path2 = '/video'
        if (newVal.query.two == '教学视频') {
          this.choseItem = []
          this.getVideoLists()
          this.getTypes()
        } else if (newVal.query.two == '教学教材') {
          this.choseItem = []
          this.materialList()
          this.materialType()
          this.getCourseType()
        }
      },
      deep: true,
    },
  },

  methods: {
    imgError(e) {
      e.target.src = 'http://cdn.uviewui.com/uview/empty/data.png'
    },
    choseType(item) {
      if (!this.choseItem.includes(item.id)) {
        this.choseItem.push(item.id)
      } else {
        let i = this.choseItem.indexOf(item.id)
        this.choseItem.splice(i, 1)
      }
      if (this.routeQuery.two == '教学视频') {
        this.getVideoLists()
      } else {
        this.materialList()
      }
    },
    choseCourseType(item) {
      if (!this.courseChoseItem.includes(item.id)) {
        this.courseChoseItem.push(item.id)
      } else {
        let i = this.courseChoseItem.indexOf(item.id)
        this.courseChoseItem.splice(i, 1)
      }
      if (this.routeQuery.two == '教学视频') {
        this.getVideoLists()
      } else {
        this.materialList()
      }
    },
    clearChose() {
      this.choseItem = []
      if (this.routeQuery.two == '教学视频') {
        this.getVideoLists()
      } else {
        this.materialList()
      }
    },
    clearCourseChose() {
      this.courseChoseItem = []
      this.materialList()
    },
    getVideoLists() {
      getVideoList(this.currPage, this.limit, this.choseItem.toString()).then(
        (res) => {
          if (res.data.statusCode == 1) {
            this.videoData = res.data.obj.data
            this.total = res.data.obj.count
            this.pageNum = 1
            if (res.data.obj.count > 0) {
              this.pageNum = Math.ceil(this.total / this.limit)
            }
          }
        }
      )
    },
    getTypes() {
      getVideoTypes().then((res) => {
        if (res.data.statusCode == 1) {
          this.lists = res.data.obj
        }
      })
    },
    materialList() {
      getMaterialList(
        this.currPage,
        this.limit,
        this.choseItem.toString(),
        this.courseChoseItem.toString()
      ).then((res) => {
        if (res.data.statusCode == 1) {
          this.videoData = res.data.obj.data
          this.total = res.data.obj.count
          this.pageNum = 1
          if (res.data.obj.count > 0) {
            this.pageNum = Math.ceil(this.total / this.limit)
          }
        }
      })
    },
    materialType() {
      getMaterialType().then((res) => {
        if (res.data.statusCode == 1) {
          this.lists = res.data.obj
        }
      })
    },
    getCourseType() {
      getCourseType().then((res) => {
        if (res.data.statusCode == 1) {
          this.courseTypeList = res.data.obj
        }
      })
    },
    videoPlay(item) {
      if (this.routeQuery.two == '教学教材') {
        const { href } = this.$router.resolve({
          path: '/bookDetail',
          query: {
            one: this.routeQuery.one,
            two: this.routeQuery.two,
            three: '教材详情',
            path1: '/teaching',
            path2: '/video',
            path: '',
            bookId: item.eduMaterialId,
          },
        })
        window.open(href, '_blank')
      } else {
        if (item.external) {
          window.open(item.url, '_blank')
        } else {
          const { href } = this.$router.resolve({
            path: '/videoPlay',
            query: {
              one: this.routeQuery.one,
              two: this.routeQuery.two,
              path1: '/teaching',
              path2: '/video',
              three: '',
              path: '',
              videoId: item.id,
            },
          })
          window.open(href, '_blank')
        }
      }
    },
    changeToFirst() {
      this.currPage = 1
      if (this.routeQuery.two == '教学视频') {
        this.getVideoLists()
      } else {
        this.materialList()
      }
    },
    changeToPrev() {
      if (this.currPage > 1) {
        this.currPage -= 1
        if (this.routeQuery.two == '教学视频') {
          this.getVideoLists()
        } else {
          this.materialList()
        }
      }
    },
    changeToNext() {
      if (this.currPage < Math.ceil(this.total / this.limit)) {
        this.currPage += 1
        if (this.routeQuery.two == '教学视频') {
          this.getVideoLists()
        } else {
          this.materialList()
        }
      }
    },
    changeToLast() {
      this.currPage = Math.ceil(this.total / this.limit)
      if (this.routeQuery.two == '教学视频') {
        this.getVideoLists()
      } else {
        this.materialList()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.breadlist,
.type-label-list,
.video-list,
.page,
.typeTitle {
  width: 1100px;
  margin-left: calc(50% - 550px);
}
.type-label {
  //   width: 77px;
  height: 32px;
  background: #f1f2f3;
  border: 1px solid #e8e8e8;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 8px;
  margin-right: 16px;
}
.type-label-list {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
}
.video-list {
  min-height: 432px;
  margin-top: 24px;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  justify-items: center;
}
.video-one {
  margin-bottom: 24px;
  .video-show {
    width: 257px;
    height: 144px;
    position: relative;
    cursor: pointer;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    overflow: hidden;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    .video-play {
      background: url('../../assets/img/Play.svg') no-repeat;
      position: absolute;
      top: 50px;
      left: 104px;
      background-size: 48px;
      width: 48px;
      height: 48px;
    }
  }
  .video-discribe {
    cursor: pointer;
    width: 257px;
    .video-name {
      margin-top: 4px;
    }
    .video-date {
      color: #8b8b8b;
      margin-top: 4px;
    }
  }
}
.page {
  color: #2f2f2f;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}
.pageNum {
  color: #007a4d;
  padding-left: 5px;
  padding-right: 5px;
}
.page {
  button {
    margin-left: 14px;
    border: none;
    font-size: 13px;
    border-radius: 2px;
    padding: 2px 4px;
    color: #fff;
  }
}
.port-btn {
  width: 34px;
  height: 21px;
  background: #66af94;
  cursor: pointer;
}
.changpage-btn {
  width: 47px;
  height: 21px;
  background: #007a4d;
  cursor: pointer;
}
.default-btn {
  background: #d1d1d1 !important;
}
.chose-btn {
  background: #007a4d;
  color: #fff;
  cursor: pointer;
}
.typeTitle {
  margin-top: 8px;
}
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 64px;
}
.jc-height {
  height: 320px !important;
}
</style>
